.gallery {
  display: grid;
  grid-template-columns: 64px 1fr;
  gap: 16px;
  align-items: start;
}

.thumbs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.thumb {
  width: 64px;
  height: 64px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  padding: 4px;
  cursor: pointer;
}

.thumb img { width: 100%; height: 100%; object-fit: contain; display: block; }

.thumb.active { border-color: var(--color-ink); }

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.mainImage {
  width: 100%;
  /* Bound the image by both pixel cap and viewport height so it never
     dominates short-landscape screens (iPad mini, Pixel 7, etc).
     `min(...)` picks whichever limit is tighter for the device. */
  max-height: min(560px, 70vh);
  object-fit: contain;
  background: #fff;
}

.caption {
  font-style: italic;
  font-size: 0.85rem;
  color: var(--color-ink-soft);
}

.empty {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f3efe9;
}

@media (max-width: 768px) {
  .gallery { grid-template-columns: 1fr; }
  .thumbs { flex-direction: row; overflow-x: auto; }
}
